import heroBanner from "../../assets/images/pages/florida-driving-test.jpg";
import permitImage from "../../assets/images/pages/first-time-driver.jpg";
import ShellCard from "../../components/ShellCard.jsx";

const FloridaPermitTest = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Florida Permit Test Online</h1>
              <p className="banner-subheading">Metro Traffic School</p>
            </div>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12 col-md-5 mb-4 mb-md-0">
                  <div className="text-start">
                    <img
                      src={permitImage}
                      alt="Florida Permit Test"
                      className="img-fluid mb-4"
                      style={{ maxWidth: "100%" }}
                    />
                    <div className="d-flex flex-column">
                      <p className="mb-1 text-white">
                        To get your Florida Driving Test started, click{" "}
                        <a
                          href="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzg1&_gl=1*1b3rstc*_gcl_au*MTY2MzE2OTE1Ny4xNzYzMzkxMDc3"
                          className="text-decoration-none fw-bold text-warning"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Register Now!
                        </a>
                      </p>
                      <a
                        href="/florida-driver-handbook"
                        className="text-decoration-none fw-bold text-warning"
                      >
                        Click here for the Driver's Handbook
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-7">
                  <div className="mb-4">
                    <h5 className="mb-3 fw-bold text-warning">
                      No need to wait in line at the DMV! Take your Florida
                      Permit Test ONLINE!
                    </h5>
                    <p className="lh-lg text-white">
                      Anyone under the age of 18 is eligible to complete the
                      Florida Permit Online Test! It does not matter how, where,
                      or with whom you completed the 4-hour First Time Driver
                      Drug and Alcohol program. Even if you completed the First
                      Time Driver course in a classroom with us or any other
                      school, you are still eligible to register for our online
                      Florida Driving Test.
                    </p>
                  </div>

                  <div className="mb-1">
                    <p className="lh-lg text-white">
                      Our online Florida Driving Test can be taken by those
                      getting a learner permit or restricted license and those
                      getting a Florida Driver License. The Florida Class E
                      Permit Online Exam will consist of 50 questions that will
                      cover:
                    </p>
                    <ul className="mb-2 text-white">
                      <li>Road Signs</li>
                      <li>Road Rules</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <p className="lh-lg text-white">
                      If you have any questions, feel free to call us at{" "}
                      <a
                        href="tel:1-888-41-Metro"
                        className="fw-bold text-decoration-none text-warning"
                      >
                        1-888-41-Metro
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center mt-5">
                <div className="col-12 col-md-6">
                  <div
                    className="p-4 rounded mb-4 text-center"
                    style={{
                      backgroundColor: "#252525",
                      borderRadius: "8px",
                      border: "2px solid var(--metro-yellow)",
                    }}
                  >
                    <h3 className="text-white mb-3">Florida Permit Test Online</h3>
                    <div className="mb-3">
                      <span
                        className="display-5 fw-bold"
                        style={{ color: "var(--metro-yellow)" }}
                      >
                        $24.95
                      </span>
                    </div>
                    <p className="text-white mb-3">Make a secure payment now using your debit or credit card.</p>

                    <div className="d-flex flex-wrap justify-content-center gap-3">
                      <a
                        href="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzg1&_gl=1*1b3rstc*_gcl_au*MTY2MzE2OTE1Ny4xNzYzMzkxMDc3"
                        target="blank"
                        rel="noopener noreferrer"
                        className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                      >
                        Register Now!
                      </a>
                      <a
                        href="/first-time-driver"
                        target="blank"
                        rel="noopener noreferrer"
                        className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-secondary text-decoration-none"
                      >
                        Buy a Package & Save!
                      </a>
                    </div>
                  </div>

                  <div className="text-center">
                    <p
                      className="fst-italic text-white"
                      style={{ fontSize: "14px" }}
                    >
                      * All who complete the DMV Test, outside of the DMV office
                      are subject to random re-examination.
                    </p>
                  </div>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default FloridaPermitTest;
